import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NgrxStoreKeys } from '@warema/warema-plus/models';
import { activityAdapter, ActivityState } from './activity.reducers';

const { selectAll } = activityAdapter.getSelectors();
const selectFeatureActivityState = createFeatureSelector<ActivityState>(NgrxStoreKeys.ACTIVITY_FEATURE_KEY);

export const selectAllActivities = createSelector(selectFeatureActivityState, (state: ActivityState) =>
    selectAll(state),
);
export const selectSelectedActivity = createSelector(
    selectFeatureActivityState,
    (state: ActivityState) => state.selectedActivity,
);
